import { Stack } from "@mui/material";
import { CommonLabel } from "./common-label";
import { CommonSwitch } from "./common-switch";

export const LabeledSwitch = ({
  label = "",
  labelColor = "text.secondary",
  checked = false, // ✅ 항상 boolean으로 (undefined -> false)
  onChange = () => {}, // ✅ onChange 없을 때도 안전하게
  fontSize = 11,
  disabled = false,
}) => {
  const safeChecked = !!checked;
  return (
    <Stack
      direction="row"
      spacing={0.2}
      alignItems="center"
    >
      <CommonLabel
        label={label}
        color={labelColor}
        fontSize={fontSize}
      />
      <CommonSwitch
        checked={safeChecked} // ✅ 항상 값이 있음 (false 또는 true)
        onChange={onChange}
        disabled={disabled}
      />
    </Stack>
  );
};
